import { useEffect, useState, useCallback } from "react";
import { CampaignsByUuidAccount } from "../../../services/api/Campaigns/CampaignsByUuidAccount";
import use123zapStore from "../../../context/123zapStore";
import { useAuth } from "../../../app/providers/AuthProvider";
import { getStoredCampaignCategory } from "../utils/campaignCategoryStorage";

export function useCampaignsData() {
  const { isAuthenticated } = useAuth();

  const campaigns = use123zapStore((s) => s.campaigns);
  const setCampaigns = use123zapStore((s) => s.setCampaigns);
  const alreadyFetch = use123zapStore((s) => s.alreadyFetchCampaigns);
  const setAlreadyFetch = use123zapStore((s) => s.setAlreadyFetchCampaigns);

  const [loading, setLoading] = useState(!alreadyFetch);
  const [isFetching, setIsFetching] = useState(false);

  const normalizeStatus = (status) => {
    const s = String(status).toLowerCase();
    if (s === "true" || s === "active") return "Active";
    if (s === "removed") return "Removed";
    return "Desativado";
  };

  const fetchCampaigns = useCallback(
    async ({ silent = false } = {}) => {
      try {
        silent ? setIsFetching(true) : setLoading(true);

        const resultJson = await CampaignsByUuidAccount();

        const data = (resultJson.campaigns || [])
          .filter((item) => String(item.status).toLowerCase() !== "removed")
          .map((item) => {
            const storedCategory = getStoredCampaignCategory(item.code);

            return {
              id: item.code,
              title: item.title,
              start_date: item.start_date,
              start_time: item.start_time,
              expiration_date: item.expiration_date,
              status: normalizeStatus(item.status),
              icon: "Campanha",
              desc: item.description,
              description: item.description,
              list_id: item.list_id,
              dynamic_date: item.dynamic_date,
              key_date_row: item.key_date_row,
              reference_moment: item.reference_moment,
              days_calculate: item.days_calculate,
              business_days: item.business_days,
              block_dynamic: item.block_dynamic,
              key_block: item.key_block,
              when_block: item.when_block,
              value_blocked: item.value_blocked,
              whatsapp_id: item.whatsapp_id,
              sms_id: item.sms_id,
              email_id: item.email_id,
              visibility: item.visibility,
              Visibility: item.visibility === true ? "Visível" : "Oculto",
              campaign_type: item.type,
              category: storedCategory,
              model_whatsapp_id: item.model_whatsapp_id,
              model_sms_id: item.model_sms_id,
              model_email_id: item.model_email_id,
              start_immediately: item.start_immediately,
            };
          });

        setCampaigns(data);
        setAlreadyFetch(true);
      } catch (error) {
        console.error("Erro ao carregar campanhas:", error);
      } finally {
        setLoading(false);
        setIsFetching(false);
      }
    },
    [setCampaigns, setAlreadyFetch]
  );

  useEffect(() => {
    if (!isAuthenticated || alreadyFetch) return;

    fetchCampaigns();
  }, [isAuthenticated, alreadyFetch, fetchCampaigns]);

  return {
    campaigns,
    loading,
    isFetching,
    refetch: () => fetchCampaigns({ silent: true }),
  };
}
